import axios from 'axios'

const isAdmin = window.User !== undefined ? window.User.role.name === 'Administrator' : {}
const endpoint_app_usage = isAdmin ? '/api/v2/dashboard/admin/app-usage' : '/api/v2/dashboard/user/app-usage'
const endpoint_expense_summary = isAdmin ? '/api/v2/dashboard/admin/expense-summary' : '/api/v2/dashboard/user/expense-summary'
const endpoint_attendance_summary = isAdmin ? '/api/v2/dashboard/admin/attendance-summary' : '/api/v2/dashboard/user/attendance-summary'

// Define app_usage module
export const app_usage = {
  state: {
    data: {}
  },
  getters: {
    getAppUsage: state => {
      return state.data
    }
  },
  mutations: {
    setAppUsage (state, payload) {
      state.data = payload
    }
  },
  actions: {
    async getAppUsage ({ commit }, payload) {
      try {
        const response = await axios.post(endpoint_app_usage, payload)
        if (response.status === 200) {
          commit('setAppUsage', response.data.data)
        }
      } catch (error) {
        Promise.reject(error)
      }
    }
  }
}

// Define expense_summary module
export const expense_summary = {
  state: {
    data: {}
  },
  getters: {
    getExpenseSummary: state => {
      return state.data
    }
  },
  mutations: {
    setExpenseSummary (state, payload) {
      state.data = payload
    }
  },
  actions: {
    async getExpenseSummary ({ commit }, payload) {
      try {
        const response = await axios.post(endpoint_expense_summary, payload)
        if (response.status === 200) {
          commit('setExpenseSummary', response.data.data)
        }
      } catch (error) {
        Promise.reject(error)
      }
    }
  }
}

// Define attendance_summary module
export const attendance_summary = {
  state: {
    data: {}
  },
  getters: {
    getAttendanceSummary: state => {
      return state.data
    }
  },
  mutations: {
    setAttendanceSummary (state, payload) {
      state.data = payload
    }
  },
  actions: {
    async getAttendanceSummary ({ commit }, payload) {
      try {
        const response = await axios.post(endpoint_attendance_summary, payload)
        if (response.status === 200) {
          commit('setAttendanceSummary', response.data.data)
        }
      } catch (error) {
        Promise.reject(error)
      }
    }
  }
}
